module.exports = __webpack_public_path__ + "static/media/messages.1aeb32a0.svg";